






































































































































import { v4 as uuidv4 } from 'uuid';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';

@Component({
  name: 'bulk-recover-modal',
  components: {},
})
export default class BulkRecoverModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'bulk-recover' }) readonly modalId: string;
  @Prop({ type: String, default: null }) readonly entityName: string;
  @Prop({ type: Object, default: null }) readonly filters: object;
  @Prop({ type: Object, default: null }) readonly searchAndOrder: SearchAndOrder;
  @Prop({ type: Array, default: () => [] }) readonly selectedEntities: string[];
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({ type: Array, default: () => [] }) readonly dataToShow: [string[]];

  // Data
  public recoverEventsError: object[] = [];
  public recoverEventsSuccess: object[] = [];
  public recoverRequestSent: boolean = false;
  public isRecovering: boolean = false;
  public reportPerPage: number = 20;
  public reportCurrentPage: number = 1;
  public processAll: boolean = false;

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Computed
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
  get title() {
    return this.$t('global.modals.bulk-recover.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get body() {
    return this.$t('global.modals.bulk-recover.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get reportRows() {
    return this.recoverEventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.recoverEventsError.slice(start, end);
  }

  // Methods
  openModal(): void {
    this.resetModal();
    this.$bvModal.show(this.modalId);
  }
  closeModal(): void {
    this.resetModal();
    this.$bvModal.hide(this.modalId);
  }
  resetModal(): void {
    this.recoverEventsError = [];
    this.recoverEventsSuccess = [];
    this.recoverRequestSent = false;
    this.isRecovering = false;
    // NOTE important to reset this value otherwise the next time the modal
    // is opened it will be potentially true
    this.processAll = false;
  }
  onConfirmRecover(): void {
    const basePath = this.$bpcApiRouteHelper.getEntityPath(this.entityName);
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketRecoverChannel(sessionCode);
    this.recoverRequestSent = true;

    this.$bpcApi
      .post(basePath + '/bulk-recover', {
        entities: this.selectedEntities,
        filters: this.filters,
        search_and_order: this.searchAndOrder,
        process_all: this.processAll,
        session_code: sessionCode,
      })
      .subscribe(
        res => {
          this.$emit('request-sent');
        },
        error => {
          this.$emit('error-sending-request');
          this.$bpcEcho.leaveRecoverChannel(sessionCode);
          this.resetModal();
        },
      );
  }
  getSessionCode(): string {
    return `recover-${this.tenantId}-${uuidv4()}`;
  }
  listenToWebsocketRecoverChannel(sessionCode): void {
    this.isRecovering = true;
    this.$bpcEcho
      .listenRecoverChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\EntitiesRecovered', data => {
        this.$bpcMessage.showInfoMessage({
          text: 'global.actions.bulk_recover.entities_recovered',
        });
        this.isRecovering = false;
        this.$emit('recovered');
        this.$bpcEcho.leaveRecoverChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\EntityRecovered', data => {
        this.recoverEventsSuccess.push(data);
      })
      .listen('.BPC\\Core\\Events\\ErrorRecoveringEntity', data => {
        this.recoverEventsError.push(data);
      });
  }
  onCloseModal(): void {
    this.$emit('on-close-modal');
  }

  // Watchers
  @Watch('showModal')
  onChangeShowModal(val) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
